'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _itemList = require('./item-list.component');

var _itemList2 = _interopRequireDefault(_itemList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.common.item-list', []).component('itemList', _itemList2.default).name;


// WEBPACK FOOTER //
// ./components/app/common/item-list/item-list.module.js